import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../data/landing";
import { useLanguage } from "../i18n/LanguageContext";
import StoreButtons from "../components/landing/StoreButtons";

const fade = {
  hidden: { opacity: 0, y: 20 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

// Standalone single-screen ad landing — full-bleed maroon canvas.
export default function InstantLanding() {
  const { t } = useLanguage();

  return (
    <main
      className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-[#7B1113] px-6 py-14 sm:px-10 sm:py-16"
      data-testid="instant-landing"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 55% at 50% 45%, rgba(245,166,35,0.18) 0%, rgba(123,17,19,0) 65%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 left-1/2 h-[380px] w-[380px] -translate-x-1/2 rounded-full bg-[#F5A623]/25 blur-[130px]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-32 -right-16 h-[340px] w-[340px] rounded-full bg-[#F5A623]/12 blur-[110px]"
      />
      <div className="grain-overlay opacity-[0.05]" />

      <div className="relative z-10 flex w-full max-w-2xl flex-col items-center text-center">
        <motion.img
          src={ASSETS.logo}
          alt={t.brand}
          initial={{ opacity: 0, scale: 0.85, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          data-testid="instant-logo"
          className="mb-10 h-32 w-32 rounded-full object-cover shadow-[0_18px_40px_-10px_rgba(0,0,0,0.55)] sm:mb-12 sm:h-40 sm:w-40"
        />

        <motion.h1
          variants={fade}
          initial="hidden"
          animate="show"
          className="text-4xl font-semibold leading-[1.05] tracking-tight text-[#FCFAF7] sm:text-6xl md:text-[4.25rem] lg:text-[5rem]"
          data-testid="instant-heading"
        >
          Hari Om Bol
        </motion.h1>

        <motion.p
          variants={fade}
          custom={1}
          initial="hidden"
          animate="show"
          className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-[#FCFAF7]/90 sm:mt-7 sm:text-lg md:text-xl lg:text-[1.35rem]"
          data-testid="instant-subtitle"
        >
          Download our Mobile App to connect with{" "}
          <span className="font-semibold text-[#F5A623]">Verified, Real Astrologers</span>
          {" "}and{" "}
          <span className="font-semibold text-[#F5A623]">Compassionate Saathi&apos;s</span>
        </motion.p>

        <motion.div
          variants={fade}
          custom={2}
          initial="hidden"
          animate="show"
          className="mt-10 flex w-full justify-center sm:mt-12"
        >
          <StoreButtons
            align="center"
            testidPrefix="instant"
            size="xl"
            stack
          />
        </motion.div>
      </div>
    </main>
  );
}
